import { render, staticRenderFns } from "./DossierEditQuickCopyCreateMoveUserData.vue?vue&type=template&id=34940e83&"
import script from "./DossierEditQuickCopyCreateMoveUserData.vue?vue&type=script&lang=ts&"
export * from "./DossierEditQuickCopyCreateMoveUserData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34940e83')) {
      api.createRecord('34940e83', component.options)
    } else {
      api.reload('34940e83', component.options)
    }
    module.hot.accept("./DossierEditQuickCopyCreateMoveUserData.vue?vue&type=template&id=34940e83&", function () {
      api.rerender('34940e83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierEditQuickCopyCreateMoveUserData.vue"
export default component.exports